import React from "react";
import { useCurrentUser } from "app/current_user/use_current_user";

export enum Role {
  CommunityTestManager = "community_test_manager",
  Customer = "customer",
  TestManager = "test_manager",
}

type AuthorizationProps = {
  roles: Role[];
  children: JSX.Element;
};

const Authorization: React.FC<AuthorizationProps> = ({ roles, children }) => {
  const currentUser = useCurrentUser();
  if (!currentUser) return null;

  return roles.includes(currentUser.role as unknown as Role) ? <>{children}</> : null;
};

export default Authorization;
